import axios from '../../axios'

/*
 * 授权小程序数据接口
 */
// 获取授权小程序列表
export const getAuthList = (data) => {
    return axios({
        url: '/api/course/tiktok/auth/page',
        method: 'get',
        data
    })
}

// 授权小程序id查询
export const getIdAuth = (data) => {
    return axios({
        url: '/api/course/tiktok/auth/get',
        method: 'get',
        data
    })
}

// 新增授权小程序信息
export const addAuth = (data) => {
    return axios({
        url: '/api/course/tiktok/auth',
        method: 'post',
        data
    })
}

// 编辑授权小程序信息
export const updateAuth = (data) => {
    return axios({
        url: '/api/course/tiktok/auth',
        method: 'put',
        data
    })
}

// 授权小程序
export const authorizationAuth = (data) => {
    return axios({
        url: '/api/course/tiktok/auth/submit',
        method: 'post',
        data
    })
}

// 解除授权小程序
export const relieveAuthorization = (data) => {
    return axios({
        url: '/api/course/tiktok/auth/un/auth',
        method: 'post',
        data
    })
}

// 查询解除授权小程序
export const searchAuthorization = (data) => {
    return axios({
        url: '/api/course/tiktok/auth/status',
        method: 'get',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/auth.js